/* ==========================================================================
   LAB BOUTIQUE PR — Shared JS
   Only one job: arrow navigation for the collections carousel.
   Works with multiple carousels on the same page and with the
   Theme Editor (re-initializes when sections reload).
   ========================================================================== */
(function () {
  'use strict';

  function initCarousels(root) {
    var carousels = (root || document).querySelectorAll('[data-lab-carousel]');
    carousels.forEach(function (carousel) {
      if (carousel.dataset.labInit === 'true') return;
      carousel.dataset.labInit = 'true';

      var track = carousel.querySelector('[data-lab-track]');
      var prev = carousel.querySelector('[data-lab-prev]');
      var next = carousel.querySelector('[data-lab-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.lab-collection-card');
        return card ? card.getBoundingClientRect().width + 16 : 300;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  } else {
    initCarousels();
  }

  // Re-init when the Theme Editor reloads a section
  document.addEventListener('shopify:section:load', function (e) {
    initCarousels(e.target);
  });
})();